import { render, staticRenderFns } from "./IrrigationPlanDetail.vue?vue&type=template&id=05bed701&scoped=true&"
import script from "./IrrigationPlanDetail.vue?vue&type=script&lang=ts&"
export * from "./IrrigationPlanDetail.vue?vue&type=script&lang=ts&"
import style0 from "./IrrigationPlanDetail.vue?vue&type=style&index=0&id=05bed701&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bed701",
  null
  
)

export default component.exports